import React, { useEffect, useState } from "react";
import api from "../../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "../loader";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Plus, X } from "lucide-react";

function AdminLiveTrades({ adminType }) {
  const adminStore = useSelector((state) => state.adminReducer);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [data, setData] = useState([]);
  const [noTrade, setNoTrade] = useState(0);
  const [loader, setLoader] = useState(true);
  const [inputData, setInputData] = useState({});
  const [prices, setPrices] = useState({});
  const [hasOpenTrades, setHasOpenTrades] = useState(false);

  const [stats, setStats] = useState({
    short: 0,
    long: 0,
    open: 0,
    closed: 0,
    total: 0,
  });

  const getTradeData = async (p, filters) => {
    try {
      console.log(filters);

      const payload = { page: p, ...filters };
      setLoader(true);
      const resp = await api.liveTradeGetAdmin(payload);
      setData(resp.trades);
      setNoTrade(resp.total);
      setLimit(resp.limit);
      setPrices(resp?.prices);

      const openExists = resp.trades.some((t) => t.status === "OPEN");
      setHasOpenTrades(openExists);

      // setStats({
      //   pending: pendingCount,
      //   processing: processingCount,
      //   closed: closedCount,
      //   total: resp.count,
      // });

      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  const handleReset = () => {
    setInputData({});
    setPage(1);
  };

  useEffect(() => {
    getTradeData(page, inputData);
  }, [inputData, page]);

  useEffect(() => {
    if (!hasOpenTrades) return;

    const interval = setInterval(() => {
      getTradeData(page, inputData);
    }, 15000);

    return () => clearInterval(interval);
  }, [hasOpenTrades]);

  return (
    <>
      <div className="container-fluid admin-dashboard support-tickets-page">
        {/* Stats Cards */}
        {/* <div className="row stats-overview mb-4">
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="stat-card primary-gradient">
              <div className="stat-icon">
                <i className="fas fa-ticket-alt"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats?.total}</div>
                <div className="stat-label1">Total Trades</div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="stat-card warning-gradient">
              <div className="stat-icon">
                <i className="fas fa-clock"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats?.pending}</div>
                <div className="stat-label1">OPEN</div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="stat-card info-gradient">
              <div className="stat-icon">
                <i className="fas fa-spinner"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.processing}</div>
                <div className="stat-label1">CLOSED</div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-md-6 mb-4">
            <div className="stat-card success-gradient">
              <div className="stat-icon">
                <i className="fas fa-check-circle"></i>
              </div>
              <div className="stat-content">
                <div className="stat-value">{stats.closed}</div>
                <div className="stat-label1">Closed</div>
              </div>
            </div>
          </div>
        </div> */}

        {/* Page Header */}
        <div className="row page-header mb-4">
          <div className="col-12">
            <div className="page-header-card">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h1 className="page-title">Live Trades</h1>
                  <p className="page-subtitle">
                    Manage and monitor all live trades
                  </p>
                </div>
                <div className="header-actions">
                  {/* <button
                    className="btn-action refresh-btn"
                    onClick={() => getTradeData(page, inputData)}
                    title="Refresh"
                  >
                    <i className="fas fa-sync-alt"></i> Refresh
                  </button> */}
                  <AddTrade getTradeData={getTradeData} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Filter Section */}
        <div className="row filter-section mb-4">
          <div className="col-12">
            <div className="filter-card">
              <div className="filter-header">
                <div className="filter-label">
                  <i className="fas fa-filter"></i> Filter Trade
                </div>
              </div>
              <div className="filter-body">
                <div className="row g-3">
                  <div className="col-md-3">
                    <div className="filter-group">
                      <label className="filter-label-small">Position</label>
                      <div className="select-wrapper">
                        <i className="fas fa-caret-down select-arrow"></i>
                        <select
                          name="position"
                          onChange={(e) =>
                            setInputData({
                              ...inputData,
                              position: e.target.value,
                            })
                          }
                          value={inputData?.position}
                          className="filter-select"
                        >
                          <option value="">Select Issue</option>
                          <option value="LONG">LONG</option>
                          <option value="SHORT">SHORT</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="filter-group">
                      <label className="filter-label-small">Status</label>
                      <div className="select-wrapper">
                        <i className="fas fa-caret-down select-arrow"></i>
                        <select
                          name="status"
                          onChange={(e) =>
                            setInputData({
                              ...inputData,
                              status: e.target.value,
                            })
                          }
                          value={inputData?.status}
                          className="filter-select"
                        >
                          <option value="">Select Status</option>
                          <option value="OPEN">OPEN</option>
                          <option value="CLOSED">CLOSED</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="filter-actions mt-3">
                  <button
                    className="themeBlackBtn"
                    onClick={() => handleReset()}
                  >
                    <i className="fas fa-redo"></i> Reset Filters
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Main Table */}
        <div className="row">
          <div className="col">
            <Table
              data={data}
              setPage={setPage}
              page={page}
              noTrade={noTrade}
              limit={limit}
              prices={prices}
            />
          </div>
        </div>
      </div>

      {loader && <Loader />}
    </>
  );
}

const Table = ({ data, page, setPage, noTrade, limit, prices }) => {
  const [activeImg, setActiveImg] = useState("");
  const [showMore, setShowMore] = useState(false);
  const handleCloseMore = () => setShowMore(false);
  const handleShowMore = () => setShowMore(true);
  const navigate = useNavigate();

  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const handleActiveImg = (link) => {
    setActiveImg(link);
    handleShowMore();
  };

  const calcPnl = (trade, livePrice) => {
    if (!livePrice || trade.status !== "OPEN") return null;

    return trade.position === "LONG"
      ? livePrice - trade.entryPrice
      : trade.entryPrice - livePrice;
  };

  const calcPnlPercent = (trade, livePrice) => {
    const pnl = calcPnl(trade, livePrice);
    if (pnl === null) return null;
    return ((pnl / trade.entryPrice) * 100).toFixed(2);
  };

  return (
    <>
      <div className="card modern-table-card">
        <div className="table-header-section">
          <div className="table-title-group flex-wrap p-3">
            <h3 className="table-title">All Trades</h3>
            <span className="table-subtitle">{noTrade} trade found</span>
          </div>
        </div>

        <div className="table-responsive">
          <table className="table modern-table tickets-table">
            <thead className="table-header">
              <tr>
                <th className="table-head-cell">Coin</th>
                <th className="table-head-cell">Position</th>
                <th className="table-head-cell">Entry Price</th>
                <th className="table-head-cell">Target Price</th>
                <th className="table-head-cell">Closed Price</th>
                <th className="table-head-cell">Status</th>
                <th className="table-head-cell">Closed Reason</th>
                {/* <th className="table-head-cell">PNL</th> */}
                <th className="table-head-cell">PNL %</th>
                <th className="table-head-cell">Opened At</th>
                <th className="table-head-cell">Closed At</th>
              </tr>
            </thead>
            <tbody className="table-body">
              {data.map((item, key) => (
                <tr key={key} className="table-row">
                  <td className="table-cell">
                    <div className="issue-id">{item?.coin}</div>
                  </td>
                  <td className="table-cell">
                    <div className="user-email">{item?.position}</div>
                  </td>
                  <td className="table-cell">
                    <div>{item?.entryPrice}</div>
                  </td>
                  <td className="table-cell">
                    <div className="issue-type">{item?.targetPrice}</div>
                  </td>
                  <td className="table-cell">
                    <div className="issue-type">{item?.closedPrice || "-"}</div>
                  </td>

                  <td className="table-cell">
                    <div
                      className={`status-badge ${item?.status == "OPEN" ? "status-processing" : "status-closed"}`}
                    >
                      {item?.status}
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="issue-type">{item?.closeReason || "-"}</div>
                  </td>
                  {/* <td className="table-cell">
                    {calcPnl(item, prices[item.coin])?.toFixed(4) ?? "-"}
                  </td> */}
                  <td className="table-cell">
                    {item.status === "OPEN" && prices?.[item.coin] ? (
                      <span
                        className={
                          calcPnl(item, prices[item.coin]) >= 0
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {calcPnlPercent(item, prices[item.coin])}%
                      </span>
                    ) : item.status === "CLOSED" && item.closedPrice ? (
                      <span
                        className={
                          calcPnl(item, item.closedPrice) >= 0
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {calcPnlPercent(item, item.closedPrice) || 0}%
                      </span>
                    ) : (
                      "-"
                    )}
                  </td>

                  <td className="table-cell">
                    <div className="created-at">
                      {formatDate(item?.openedAt)}
                    </div>
                  </td>
                  <td className="table-cell">
                    <div className="created-at">
                      {item?.closedAt ? formatDate(item?.closedAt) : "-"}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {data.length === 0 && (
          <div className="empty-table-state">
            <div className="empty-state-content">
              <i className="fas fa-ticket-alt empty-state-icon"></i>
              <h4 className="empty-state-title">No trade found</h4>
              <p className="empty-state-description">
                There are no trade matching your criteria.
              </p>
            </div>
          </div>
        )}

        {data.length > 0 && (
          <div className="table-footer">
            <div className="table-info">
              Showing {data.length} of {noTrade} trade • Page {page} of{" "}
              {Math.ceil(noTrade / limit)}
            </div>
            <div className="table-pagination">
              <Stack spacing={2}>
                <Pagination
                  count={Math.ceil(noTrade / limit)}
                  page={page}
                  onChange={handleChange}
                  color="primary"
                  shape="rounded"
                />
              </Stack>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const AddTrade = ({ getTradeData }) => {
  const [inputData, setInputData] = useState({});
  const [loader, setLoader] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleChange = (e) => {
    // console.log(e);
    setInputData({ ...inputData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      if (!inputData?.coin && !inputData?.position && !inputData?.targetPrice) {
        setLoader(false);
        alert("Please fill required fields.");
        return;
      }

      setLoader(true);
      const formData = {
        coin: inputData?.coin,
        position: inputData?.position,
        entryPrice: inputData?.entryPrice || "",
        targetPrice: inputData?.targetPrice,
      };

      // console.log(formData);

      const signalResponse = await api.liveTradeCreate(formData);
      if (signalResponse?.success) {
        alert("Form submited");
        setInputData({
          position: "",
        });

        setLoader(false);
        setShow(false);
        getTradeData();
      } else {
        setLoader(false);
        alert("Something went wrong");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      alert("Something went wrong");
    }
  };

  return (
    <>
      <button className="add-video-btn" onClick={handleShow}>
        <Plus size={20} />
        <span>Add Trade</span>
      </button>
      <Modal
        show={show}
        size="lg"
        onHide={handleClose}
        centered
        className="modern-modal"
      >
        <Modal.Body>
          <div className="modal-content-wrapper">
            <div className="modal-header">
              <h2 className="modal-title">Add Trade</h2>
              <button className="close-modal-btn" onClick={handleClose}>
                <X size={24} />
              </button>
            </div>
            <div className="modal-body-content">
              <div className="card sortby-box br-10 border-transparent mt-3">
                <div className="card-header br-10  bg-white border-transparent py-3 ">
                  <div className="descMainPost">
                    <div className="form-group mb-3">
                      <input
                        type="text"
                        name="coin"
                        className="form-control"
                        onChange={handleChange}
                        placeholder="Add Coin*"
                      />
                    </div>
                  </div>
                  <div className="form-group mb-3">
                    <select
                      name="position"
                      onChange={handleChange}
                      className="form-control"
                    >
                      <option value="">Select Position*</option>
                      <option value="LONG">LONG</option>
                      <option value="SHORT">SHORT</option>
                    </select>
                  </div>
                  <div className="form-group mb-3">
                    <input
                      type="number"
                      name="entryPrice"
                      className="form-control"
                      onChange={handleChange}
                      placeholder="Add Entry Price"
                    />
                  </div>
                  <div className="form-group mb-3">
                    <input
                      type="number"
                      name="targetPrice"
                      className="form-control"
                      onChange={handleChange}
                      placeholder="Add Target Price*"
                    />
                  </div>

                  <div className="sendMailBtn mt-3">
                    <button
                      onClick={handleSubmit}
                      className="btn-dark"
                      disabled={loader}
                    >
                      {loader && (
                        <i
                          className="fa fa-spinner fa-pulse mx-2 mb-1"
                          style={{ position: "relative", top: "-0px" }}
                        ></i>
                      )}
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AdminLiveTrades;
